<template>
  <div class="threeDModel">
    <el-carousel
      indicator-position="none"
      :interval="5000"
      :height="imgHeight + 'px'"
    >
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img :src="item.value" alt="" style="width: 100%" ref="image" />
      </el-carousel-item>
    </el-carousel>
    <!-- 参赛须知 -->
    <div class="threeDModel_msg">
      <h4 class="threeDModel_title">参赛须知</h4>
      <div class="threeDModel_msgbox">
        <div>
          1.增材云模型征集现金奖励活动有3大分类2大活动奖励；3大分类分别是人物角色、娱乐玩具、工业模型。2大活动奖励分别为模型作品奖励、设计师评选奖励。
          <br />
          2.本次模型征集对象面向2大人群，高校组（机械类/设计类/艺术类等专业高校学生）与社会组（自由设计师、设计公司、建模师等）。
          <br />
          3.模型作品奖励：设计师每上传一个模型作品，审核通过后高校组获奖励金额5元/个，社会组获得奖励金额3元/个，设计师每个分类最多上传150个模型作品，超过部分不参与奖励。
          <br />
          4.设计师评选奖励：最终评选出杰出设计师2名（奖励300元），优秀设计师3名（奖励200元）。
          <br />
          5.活动奖池15000元，个人最高可获1000元。奖池分完，活动立即停止，后续作品将不参与奖励。
          <br />
          6.模型作品需具有原创性，能提供完整打印成品图，能够提供打印成品上色方案、渲染图等。
          <br />
          【活动参赛详细规则请下载<span class="threeD_link" @click="downloadFile(threeFu1,threeFuName1)">{{threeFuName1}}</span> .】

        </div>
        <el-button style="margin-top: 15px" type="primary" @click="isDesigner">立即参与</el-button>
      </div>
    </div>
    <!-- 参赛流程 -->
    <div class="process">
      <h4 class="threeDModel_title">参赛流程</h4>
      <div class="process_box">
        <div
          class="process_boxMsg"
          v-for="(items, index) in processList"
          :key="index"
        >
          <div>
            <i class="iconfont" :class="items.icons"></i>
            <p>{{ items.name }}</p>
          </div>
          <img class="process_img" src="../../assets/jiantou.png" alt="" />
        </div>
      </div>
      <p style="margin-bottom: 10px">详情图文参考流程请下载<span class="threeD_link" @click="downloadFile(threeFu2,threeFuName2)">{{threeFuName2}}</span> .</p>
      
    </div>
    <!-- 上传作品 -->
    <div class="upload">
      <h4 class="threeDModel_title">上传作品</h4>
      <div class="upload_box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="nameClass" label="模型分类" align="center">
          </el-table-column>
          <el-table-column prop="num" label="成功上传模型数" align="center">
          </el-table-column>
          <el-table-column prop="money" label="奖励金额" align="center">
            <template slot-scope="scope">{{scope.row.money}}元/个</template>
          </el-table-column>
          <el-table-column prop="people" label="参与人数" align="center">
            <template slot-scope="scope">{{scope.row.people}}人参与</template>
          </el-table-column>
          <el-table-column label="上传" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="isDesigner"
                >立即上传</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 热门模型 -->
    <div class="model">
      <h4 class="threeDModel_title">热门模型</h4>
      <ActiveModel></ActiveModel>
    </div>
  </div>
</template>

<script>
import ActiveModel from "./components/activemodelList.vue";
import { mapState } from "vuex";
import {
  designerByUserId,
  getNewcurrent,
  couldIn,
  matchList,
  getBannerList,
} from "../../utils/interface";
export default {
  name: "threeDModel",
  components: { ActiveModel },
  data() {
    return {
      processList: [
        {
          icons: "icon-diannao",
          name: "注册/登录",
        },
        {
          icons: "icon-zhucetianjiahaoyou",
          name: "设计师入驻",
        },
        {
          icons: "icon-yunshangchuan",
          name: "上传模型",
        },
        {
          icons: "icon-shenhe2",
          name: "审核（奖励）",
        },
        {
          icons: "icon-like",
          name: "作品评选",
        },
        {
          icons: "icon-jiangli1-mianxing",
          name: "兑现奖励",
        },
      ],
      tableData: [

      ],
      userMessages: {},
      threeFu1: "",
      threeFuName1: "",
      threeFu2: "",
      threeFuName2: "",
      bannerList: "",
      imgHeight: "",
    };
  },
  computed: {
    ...mapState({
      isLogin: "isLogin",
    }),
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (this.$refs.image) {
        this.imgHeight = this.$refs.image[0].height;
      }
    });
  },
  created() {
    this.handCurrent();
    this.getMatchList();
    this.getBanner();
  },
  methods: {
    handCurrent() {
      getNewcurrent()
        .then((res) => {
          this.userMessages = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // banner
    getBanner() {
      getBannerList({ groupCode: "MODEL_GAME" }).then((res) => {
        this.bannerList = res;
        this.imgLoad();
      });
    },
    imgLoad() {
      if (this.bannerList.length > 0) {
        this.$nextTick(function() {
          // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
          // this.imgHeight = (document.body.clientWidth * 1) / 4;
          this.imgHeightsetIn = setInterval(() => {
            if (this.imgHeight == 0) {
              this.imgHeight = this.$refs.image[0].height;
            } else {
              clearInterval(this.imgHeightsetIn);
            }
          }, 520);
        });
      }
    },
    downloadFile(fileUrl,name){
      const x = new window.XMLHttpRequest();
      x.open('GET', fileUrl, true);
      x.responseType = 'blob';
      x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.click();
      };
      x.send();
    },
    // 上传作品
    getMatchList() {
      matchList().then((res) => {
        this.tableData = [];
        if (res) {
          this.tableData.push({
            nameClass: "人物角色",
            num: res[0].taskNum,
            money: res[0].taskMoney,
            people: res[0].taskPeople,
          });
          this.tableData.push({
            nameClass: "娱乐玩具",
            num: res[0].toyNum,
            money: res[0].toyMoney,
            people: res[0].toyPeople,
          });
          this.tableData.push({
            nameClass: "工业模型",
            num: res[0].lifeNum,
            money: res[0].lifeMoney,
            people: res[0].lifePeople,
          });
          this.threeFu1 = res[0].noticeUrl;
          this.threeFuName1 = res[0].noticeName;
          this.threeFu2 = res[0].processUrl;
          this.threeFuName2 = res[0].processName;
        }
      });
    },
    isDesigner() {
      if(this.userMessages.identity == 'ENTERPRISE' || this.userMessages.identity == 'STAFF'){
        this.$message({
          message: "请切换设计师用户参与活动",
        });
        return;
      }
      if (this.isLogin) {
        if (this.userMessages.uuid) {
          designerByUserId(this.userMessages.uuid).then((res) => {
            if (res != null && res != "") {
              if (res.status == "AUDIT") {
                this.$message({
                  type: "success",
                  message: "当前用户设计师认证信息正在审核中",
                });
                this.$router.push("/designerIn");
              } else if(res.status == "REJECT"){
                this.$message({
                  type: "success",
                  message: "当前用户设计师认证信息被驳回",
                });
                this.$router.push('/designerIn');
              }else {
                window.open(
                  this.$url.designerWeb + "/#/modelManagement",
                  "_blank"
                );
              }
            }else {
              this.$router.push('/designerIn');
            }
          });
        }
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
          duration: 1200, //显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
          onClose: () => {
            //跳转页面或执行方法
            this.$router.push("/login");
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.threeDModel_title {
  font-size: 15px;
  font-weight: blod;
  color: #157efb;
  text-align: center;
  padding: 13px 0;
}
.threeD_link {
  font-size: 13px;
  cursor: pointer;
  color: #157efb;
}
.threeDModel_msg {
  background: #fafafa;
  width: 100%;
  padding-bottom: 56px;
  .threeDModel_msgbox {
    width: 1200px;
    margin: 0 auto;
    font-size: 13px;
    line-height: 26px;
  }
}
.process {
  margin: 0 auto;
  width: 1200px;
  margin-bottom: 5px;

  .process_box {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      display: inline-block;
      background: #157efb;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 22px;
    }
  }
  p {
    font-size: 13px;
    margin-top: 6px;
  }
  .process_boxMsg {
    display: flex;
    &:nth-last-child(1) .process_img{
    display: none;
  }
  }

  .process_img {
    width: 88px;
    height: 4px;
    margin-left: 36px;
    margin-top: 21px;
  }
}
.upload {
  background: #fafafa;
  width: 100%;
  padding-bottom: 20px;
  .upload_box {
    width: 1200px;
    margin: 0 auto;
    /deep/.el-table,
    .el-table__expanded-cell {
      background-color: transparent; //这是设置透明背景色
    }
    /deep/.el-table__row {
      background-color: transparent !important; //这是设置透明背景色
    }
  }
}
.model {
  background: #fafafa;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/activity/3DModel.vue